import React from 'react';
import Radium from 'radium';
import StyleDecorator from './StyleDecorator';

const Notice = (props) => {
	const style = {
		maxWidth: (props.mediaQueries.isMaxSmallDevice()) ? '480px' : 'auto',
		marginRight: 'auto',
		marginLeft: 'auto',
		lineHeight: '1.4',
		textAlign: 'left',
	};
	return (
		<div style={style}>
			{props.children}
		</div>
	);
};

Notice.propTypes = {
	children: React.PropTypes.node.isRequired,
	mediaQueries: React.PropTypes.object,
};

export default StyleDecorator(Radium(Notice));



// WEBPACK FOOTER //
// ./src/components/Notice.js